import React, { Component } from 'react';
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
import { ComPhoto, ComboBox, BookMarkStore, Alert, Confirm, NoResult } from "../../../js/ComponentManager";

/* 개발담당:양유빈
 * 화면기능:거래처 등록
 * 세부설명:
*/

export class WholeRequest extends Component {
    static displayName = WholeRequest.name;

    constructor(props) {
        super(props);
        this.state = {
            BldList: [],
            WholeList:[],
            SearchText: "",
            Title: "",
            Content: "",
            Whole_Uid:""
        };
        this.Bld_Code = "";
        this.handle_Change = this.handle_Change.bind(this);
        this.handleConnet_Click = this.handleConnet_Click.bind(this);
    }
    //초기화
    componentDidMount() {
        this.DefaultData();
    }
    //빌딩 초기화
    async DefaultData() {
        try {
            Big3Common.Util.LoadingOn();
            let Data = await Big3Common.Get("api/Common/Common/BldMgt");
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const DataSet = JSON.parse(Data.multiDataTable);
                const BldList = DataSet.BldList;
                this.setState({
                    BldList: BldList
                });
            }
        }
        catch (e) {
            console.log("DefaultData :", e);
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
    }
    handle_Change = (event) => {
        const target = event.target;
        const value = target.value.trim();
        if (target.id === "Bld_Code") {
            this.Bld_Code = value;
        }
        else {
            this.setState({ SearchText: value });
        }  
        if (event.keyCode === 13) {
            this.GetWholeList();
        }
        return false;
    }
    //거래처 검색 결과
    GetWholeList = async () => {
        try {
            if (this.Bld_Code === "") {
                this.setState({Title:"빌딩을 선택하여 주세요."})
                Big3Common.ModalAlert(bootstrap, "AlertWholeRequest");
                return false;
            }
            if (this.state.SearchText === "") {
                this.setState({ Title: "상호명을 입력하여 주세요." })
                Big3Common.ModalAlert(bootstrap, "AlertWholeRequest");
                return false;
            }
            Big3Common.Util.LoadingOn();
            let Data = await Big3Common.Post('api/MyPage/MyInfoMgr/GetRequestWholeList',
                {
                    bld_code: this.Bld_Code,
                    whole_name: this.state.SearchText,
                    use_yn:"Y"
                }
            );
            if (Data.codeName === Big3Common.ResultCode.Success) {
                this.setState({ WholeList: JSON.parse(Data.dataTable) });
            }
        }
        catch (e) {
            console.log("GetWholeList", e);
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
    }
    //거래신청
    async handleConnet_Click() {
        let Data = await Big3Common.Get(`api/Search/Store/RegisterRetailGrupApprStatus/${this.state.Whole_Uid}`);
        if (Data.codeName === Big3Common.ResultCode.Success) {
            this.setState({ Title: Data.message, ApprStatus: "WA" });
        }
        else {
            this.setState({ Title: Data.message });
        }
        Big3Common.ModalAlert(bootstrap, 'AlertWholeRequest');
        return false;
    }
    //거래신청 Confirm 창
    BusinessCall_Confirm = (list) => {
        const Content = `${list.whole_name}의 거래를 신청 하시겠습니까?`
        this.setState({
            Content: Content,
            Whole_Uid: list.uid
        });
        Big3Common.ModalAlert(bootstrap, "ConfirmWholeRequest");
        return false;
    }
    RequestBtnrender = (list) => {
        //CA: 거절,거래중지
        //WA: 거래요청, 거래대기
        //AP: 승인
        const ApprStatus =list.retail_appr_status;
        if (ApprStatus === undefined || ApprStatus === null || ApprStatus === "" || ApprStatus === "CA") {
            return (
                <div className="order_btn or_btn4" onClick={() => { this.BusinessCall_Confirm(list); }}>거래신청</div>
            )
        }
        else if (ApprStatus === "WA") {
            return (
                <>
                    <div className="order_btn or_btn5">거래대기</div>
                </>
            )
        }
        else {
            return ("");
        }
    }
    Wholerender() {
        const WholeList = this.state.WholeList;
        if (WholeList.length === 0) {
            return false;
        }
                
        return(
            <>
                {WholeList.map(list =>
                    <div className="alert_content_v2 alert_content" key={list.whole_code}>
                        <div className="alert_img">
                            <ComPhoto className="alert_img_in"
                                Photo={list.photo}
                            />
                        </div>
                        <div className="alert_txt">
                            <div className="shop_name">{list.whole_name}</div>
                            <div className="shop_address">{list.bld_name} {list.flr_name}층 {list.whole_no_name}호</div>                            
                            <BookMarkStore
                                Whole_Code={list.whole_code}
                                HeartOn={list.bookmark_yn === "Y" ? true : false}
                                CheckCss="heart_checked"
                                UnCheckCss="heart"
                            />
                            <div className="call" onClick={() => { window.location.href = `tel:${list.whole_phone}` }} ></div>
                            {this.RequestBtnrender(list) }
                        </div>
                    </div>
                )}
            </>
        )
    }
    render() {
        const Wholerender = this.Wholerender();
        return (
            <>
                <div className="tap_box">
                    <div className="t_tap"><div className="alert_tap" onClick={(e) => { this.props.RenderComponent('AccountList'); e.preventDefault(); }}>내 거래처</div></div>
                    <div className="t_tap"><div className="alert_tap" onClick={(e) => { this.props.RenderComponent('ApprovalList'); e.preventDefault(); }}>승인대기</div></div>
                    <div className="t_tap"><div className="alert_tap tap_on" >거래처 등록</div></div>
                </div>
                <div className="container_box a_margin u_padding">
                    <div className="search_box_v2">
                        <div className="select_building_box">
                            <ComboBox id="Bld_Code"
                                textName="bld_name"
                                valueName="bld_code"
                                emptyText="건물선택"
                                optionList={this.state.BldList}
                                ComboChange={this.handle_Change}
                                className="form-select form-select-sm"
                            />
                        </div>
                        <div className="select_building_box">
                            <input type="search" className="form-control"
                                maxLength="10"
                                id="SearchText"
                                value={this.state.SearchText}
                                placeholder="상호명 검색"
                                onKeyUp={this.handle_Change}
                                onChange={this.handle_Change} />
                            <div className="search_icon" onClick={() => { this.GetWholeList(); } }></div>
                        </div>
                    </div>
                   {Wholerender}
                </div>
                <Alert
                    id="AlertWholeRequest"
                    title={this.state.Title}
                />
                <Confirm
                    id="ConfirmWholeRequest"
                    title="거래안내"
                    content={this.state.Content}
                    ConfirmClick={(e) => {
                        setTimeout(() => {
                            Big3Common.ModalClose(bootstrap, 'ConfirmWholeRequest');
                        }, 500);

                        this.handleConnet_Click();
                        this.GetWholeList();
                    }}
                />
                <NoResult
                    Visible={this.state.WholeList.length === 0 ? true : false}
                    Top={"50%"}
                />
            </>
        );

    }
}
